import React, { useState } from "react";
import { Card, Dropdown, Row, Col } from "react-bootstrap";
import { FiCalendar } from "react-icons/fi";

const stats = {
  Today: {
    applicants: 487,
    hired: 24,
    avg: "28 days",
    segments: [40, 20, 23, 17],
    employees: [57, 36, 64, 18],
    training: 80
  },
  Weekly: {
    applicants: 320,
    hired: 14,
    avg: "21 days",
    segments: [35, 25, 25, 15],
    employees: [32, 22, 20, 9],
    training: 52
  },
  Yearly: {
    applicants: 1300,
    hired: 180,
    avg: "32 days",
    segments: [50, 20, 20, 10],
    employees: [420, 200, 150, 70],
    training: 140
  }
};

export default function RecruitmentStatistics() {

  const [filter, setFilter] = useState("Today");
  const data = stats[filter];

  return (
    <>
      <style>{`

      .rec-card{
        border-radius:12px;
        border:1px solid #e5e7eb;
      }

      .rec-header{
        border:1px solid #e5e7eb;
        border-left:4px solid #ff6b2c;
        border-radius:8px;
        padding:12px 14px;
        display:flex;
        justify-content:space-between;
        align-items:center;
        margin-bottom:20px;
      }

      .rec-title{
        font-weight:600;
        font-size:18px;
      }

      .rec-stat-label{
        color:#6b7280;
        font-size:14px;
      }

      .rec-stat-number{
        font-size:22px;
        font-weight:650;
      }

      .rec-progress{
        display:flex;
        height:26px;
        border-radius:20px;
        overflow:hidden;
        margin:25px 0;
      }

      .seg1{background:#f26522;}
      .seg2{background:#1f5a67;}
      .seg3{background:#ec3c8d;}
      .seg4{background:#16c25f;}

      .legend-row{
        margin-top:5px;
      }

      .legend-item{
        display:flex;
        gap:10px;
        margin-bottom:18px;
      }

      .legend-bar{
        width:4px;
        border-radius:2px;
      }

      .bar1{background:#f26522}
      .bar2{background:#1f5a67}
      .bar3{background:#ec3c8d}
      .bar4{background:#16c25f}

      .legend-title{
        font-weight:600;
      }

      .legend-sub{
        color:#6b7280;
        font-size:14px;
      }

      .training-card{
        background:#1f5a67;
        border-radius:10px;
        padding:11px;
        color:white;
        position:relative;
        overflow:hidden;
      }

      .training-bg{
        position:absolute;
        left:0;
        top:0;
        opacity:.15;
        height:100%;
      }

      .avatar-stack img{
        width:38px;
        height:38px;
        border-radius:50%;
        border:3px solid white;
        margin-left:-12px;
      }

      .donut{
        width:60px;
        height:60px;
        border-radius:50%;
        background:conic-gradient(#f26522 20%, #d1d5db 0);
        display:flex;
        align-items:center;
        justify-content:center;
        font-weight:600;
      }

      `}</style>

      {/* Recruitment Statistics */}

      <Card className="rec-card mb-3">
        <Card.Body>

          <div className="rec-header">

            <div className="rec-title">
              Recruitment Statistics
            </div>

            <Dropdown>
              <Dropdown.Toggle variant="light" className="border">
                <FiCalendar className="me-2"/> {filter}
              </Dropdown.Toggle>

              <Dropdown.Menu>
                <Dropdown.Item onClick={()=>setFilter("Today")}>
                  Today
                </Dropdown.Item>

                <Dropdown.Item onClick={()=>setFilter("Weekly")}>
                  Weekly
                </Dropdown.Item>

                <Dropdown.Item onClick={()=>setFilter("Yearly")}>
                  Yearly
                </Dropdown.Item>
              </Dropdown.Menu>

            </Dropdown>

          </div>

          {/* Top Numbers */}

          <Row className="text-center">

            <Col>
              <div className="rec-stat-label">Applicants</div>
              <div className="rec-stat-number">{data.applicants}</div>
            </Col>

            <Col>
              <div className="rec-stat-label">Hired</div>
              <div className="rec-stat-number">{data.hired}</div>
            </Col>

            <Col>
              <div className="rec-stat-label">Avg Time</div>
              <div className="rec-stat-number">{data.avg}</div>
            </Col>

          </Row>

          {/* Progress */}

          <div className="rec-progress">

            <div className="seg1" style={{width:`${data.segments[0]}%`}}></div>
            <div className="seg2" style={{width:`${data.segments[1]}%`}}></div>
            <div className="seg3" style={{width:`${data.segments[2]}%`}}></div>
            <div className="seg4" style={{width:`${data.segments[3]}%`}}></div>

          </div>

          {/* Legends */}

          <Row className="legend-row">

            <Col md={6}>

              <div className="legend-item">
                <div className="legend-bar bar1"></div>
                <div>
                  <div className="legend-title">Applications</div>
                  <div className="legend-sub">
                    {data.segments[0]}% - {data.employees[0]} Employees
                  </div>
                </div>
              </div>

              <div className="legend-item">
                <div className="legend-bar bar3"></div>
                <div>
                  <div className="legend-title">Interview</div>
                  <div className="legend-sub">
                    {data.segments[2]}% - {data.employees[2]} Employees
                  </div>
                </div>
              </div>

            </Col>

            <Col md={6}>

              <div className="legend-item">
                <div className="legend-bar bar2"></div>
                <div>
                  <div className="legend-title">Screening</div>
                  <div className="legend-sub">
                    {data.segments[1]}% - {data.employees[1]} Employees
                  </div>
                </div>
              </div>

              <div className="legend-item">
                <div className="legend-bar bar4"></div>
                <div>
                  <div className="legend-title">Hired</div>
                  <div className="legend-sub">
                    {data.segments[3]}% - {data.employees[3]} Employees
                  </div>
                </div>
              </div>

            </Col>

          </Row>

        </Card.Body>
      </Card>

      {/* Employees in Training */}

      <div className="training-card">

        <img
          src="/assets/img/bg/emp-bg.png"
          className="training-bg"
          alt=""
        />

        <Row className="align-items-center">

          <Col>

            <div>Employees in Training</div>
            <h1>{data.training}</h1>

          </Col>

          <Col className="d-flex justify-content-end align-items-center gap-3">

            <div className="avatar-stack d-flex">

              <img src="/assets/img/users/user-39.jpg"/>
              <img src="/assets/img/users/user-41.jpg"/>
              <img src="/assets/img/users/user-44-1.jpg"/>

            </div>

            <div className="donut">
              20%
            </div>

          </Col>

        </Row>

      </div>

    </>
  );
}